module.exports = __webpack_public_path__ + "img/chess_chinesechessblack5.5099f0ef.png";